module.exports = "/images/66e1470f7029d608d9cd1184fecd04c9.svg";